class PrimaryNavButton extends HTMLButtonElement {
  constructor() {
    super();

    this.navItem = this.closest(".primary-nav__item");

    this.addEventListener("focusin", this.handleFocusIn);
    this.addEventListener("focusout", this.handleFocusOut);
    this.addEventListener("click", this.handleClick);
  }

  handleFocusIn() {
    this.navItem.classList.add("primary-nav__item--focused");
  }

  handleFocusOut() {
    this.navItem.classList.remove("primary-nav__item--focused");
  }

  handleClick(event) {
    event.preventDefault();

    if (this.getAttribute("aria-expanded") === "true") {
      this.setAttribute("aria-expanded", "false");
      this.navItem.classList.remove("primary-nav__item--active");
    } else {
      this.setAttribute("aria-expanded", "true");
      this.navItem.classList.add("primary-nav__item--active");
    }
  }
}

customElements.define("primary-nav-button", PrimaryNavButton, {
  extends: "button",
});
